import { v4 as uuidv4 } from 'uuid';

export const OPTIMIZELY_FEATURES_FLAGS = {
  SMART_BANNER_DOWNLOAD: 'smart-banner-download',
  BEAUTY_EDIT_BOX_NAV: 'beauty-edit-box-nav',
  PUP_BOX_NAV: 'pup-box-nav',
};

export const MOBILE_BANNER_VARIATIONS = {
  VERSION_1: 'version_1',
  VERSION_2: 'version_2',
  CONTROL: 'control',
};

export const getUUID = () => {
  const UUID_LOCAL_STORAGE_KEY = 'FFF_gtb_uuid';
  const uuidFromLocalStorage = localStorage.getItem(UUID_LOCAL_STORAGE_KEY);
  if (!uuidFromLocalStorage) {
    localStorage.setItem(UUID_LOCAL_STORAGE_KEY, uuidv4());
  }
  return localStorage.getItem(UUID_LOCAL_STORAGE_KEY) || '';
};
